import type { PersonalDataExport } from '@escala/domain/privacy';
import { LEGAL_VERSION } from '@escala/domain/legal';
import type { AccountPrivacy, CommunicationPrefs } from '@escala/domain/types';

import type { Api } from '@/services/api/escala';

/**
 * A privacidade da conta (Privacidade e dados): o aceite dos Termos e da Política, os
 * canais de comunicação e a cópia dos dados, pelas rotas de `/privacy`. Os pedidos dos
 * titulares (`privacyRequests`) moram no estado da store, como os cadastros pelo link.
 */
export interface PrivacyClient {
  account: () => Promise<AccountPrivacy>;
  acceptTerms: () => Promise<AccountPrivacy>;
  setCommunications: (patch: Partial<CommunicationPrefs>) => Promise<AccountPrivacy>;
  exportData: () => Promise<PersonalDataExport | null>;
}

export const PRIVACY_ACCOUNT_KEY = ['privacy-account'] as const;

/** `initial` (o de `GET /auth/me`) responde a primeira leitura: o aviso de novo aceite não espera a rede. */
export function apiPrivacy(api: Api, initial?: AccountPrivacy): PrivacyClient {
  let first = initial;

  return {
    account: async () => {
      const known = first;

      first = undefined;

      return known ?? api.privacyAccount();
    },
    acceptTerms: () => api.acceptTerms(LEGAL_VERSION),
    setCommunications: api.setCommunications,
    exportData: api.exportData,
  };
}
